/*
 * @Descripttion: hqx
 * @version: 1.0.0
 * @Author: zxx
 * @Date: 2023-08-09 09:43:22
 * @LastEditTime: 2023-08-10 14:02:28
 */
import Vue from 'vue'
import Vuex from 'vuex'
import forecast from './modules/forecast'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    currentRoute: [''],
    list: [], // 海洋科普
    villageList: [] // 水乡渔村
  },
  mutations: {
    SET_LIST (state, payload) {
      state.list = payload
    }
  },
  actions: {
    oceanScience (context, payload) {
      context.commit('SET_LIST', payload)
    }
  },
  modules: {
    forecast
  }
})
